import { useState } from 'react';
import {
  Avatar, Box, Container, List, ListItem, ListItemAvatar, ListItemIcon, ListItemText,
  SvgIcon, SwipeableDrawer, Chip
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { grey } from '@mui/material/colors';
import ExitToAppOutlinedIcon from '@mui/icons-material/ExitToAppOutlined';

import Header from './Header';
import Footer from './Footer';
import { CONTADOR, useMenuUsuario } from './menuUsuario';
import { fotoDe, nombreDe } from '../common/imparte';

import { useSelector } from 'react-redux';

const Layout = ({
  busqueda = false, search = '', buscar, ...props
}) => {
  const user = useSelector(state => state.user.user);

  const [showMenu, setShowMenu] = useState(false);
  const { opciones, salir } = useMenuUsuario(showMenu);

  const navigate = useNavigate();

  const irA = where => () => {
    setShowMenu(false);
    navigate(where);
  }

  const list = () => (
    <Box
      sx={{ width: 300 }}
      onClick={() => setShowMenu(false)}
      onKeyDown={() => setShowMenu(false)}
    >
      <div className="content">
        <img src="/logo.png" width={"90%"} />
        <List className="aside">
          {/* En el celular la barra de arriba no trae tu foto (no cabe): aquí se ve quién entró. Va dentro de la lista para que se recorra
              con ella y «Cerrar sesión» siempre se alcance */}
          {user && (
            <ListItem disableGutters className="persona-menu" sx={{ mb: 1 }}>
              <ListItemAvatar>
                <Avatar src={fotoDe(user, 'w_80,h_80,c_fill') || undefined} />
              </ListItemAvatar>
              <ListItemText primary={nombreDe(user)} slotProps={{ primary: { noWrap: true, fontWeight: 500 } }} />
            </ListItem>
          )}
          {
            opciones.map((item, index) => (
              <ListItem
                key={`menu-${index}`}
                onClick={irA(item.destino)}
                className={`item-aside ${item.activo ? 'item-select' : ''}`}
              >
                <ListItemIcon>
                  <SvgIcon component={item.iconName} sx={{ color: item.activo ? grey[50] : grey[600] }} />
                </ListItemIcon>
                <ListItemText primary={item.nombre} />
                {item.contador > 0 && <Chip size="small" label={item.contador} sx={CONTADOR} />}
              </ListItem>
            ))
          }
          <ListItem onClick={salir} className="item-aside">
            <ListItemIcon>
              <ExitToAppOutlinedIcon />
            </ListItemIcon>
            <ListItemText primary="Cerrar sesión" />
          </ListItem>
        </List>
      </div>
    </Box>
  );

  return (
    <>
      <SwipeableDrawer
        anchor="left"
        open={showMenu}
        onClose={() => setShowMenu(false)}
        onOpen={() => setShowMenu(true)}
        className="aside-content"
      >
        {
          list()
        }
      </SwipeableDrawer>
      <Container maxWidth="lg" sx={{ marginBottom: '3rem', minHeight: '60vh' }}>
        <Header
          busqueda={busqueda}
          newSearch={search}
          buscar={buscar}
          showMenu={showMenu}
          changeMenu={() => setShowMenu(!showMenu)}
        />
        {
          props.children
        }
      </Container>
      <Footer />
    </>
  )
}

export default Layout;
